import { Component, Injectable, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";
import { YoyakuService } from "../service/yoyaku.service";
import {
  ActivatedRoute,
  Router,
  RouterEvent,
  NavigationEnd,
} from "@angular/router";
import { Location } from "@angular/common";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  NgbInputDatepicker,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { AViewTextModalComponent } from "../a0106-mail/a-view-text-modal.component";
import { UsersService } from "../service/users.service";
import { Role } from "../app.constant";
import { YoyakuListViewComponent } from "./yoyaku-list-view.component";
const I18N_VALUES = {
  ja: {
    weekdays: ["月", "火", "水", "木", "金", "土", "日"],
    months: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
  },
};

@Injectable()
export class I18n {
  language = "ja";
}
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}
@Component({
  selector: "yoyaku-list-app",
  templateUrl: "./yoyaku-list.component.html",
  styleUrls: ["yoyaku-list.component.css"],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  ],
})
export class YoyakuListComponent implements OnInit {
  @Input() event_id: number;
  title: string = "";

  page: number = 1;
  all_count: number = 0;
  display_per_page: number = 20; /* 最大表示件数 */

  isLoaded: boolean = false;
  selected: boolean = false;
  datalist: any = [];
  all_datalist: any = [];
  selectedList: any = [];

  selected_yoyaku_hyo_id: number = null;
  tempSelectedRow: any;
  ROLE: any = Role;

  divisionList: any = [];
  timeaxisList: any = [];
  conditionsList: any = [];
  yoyakuhyoInfo: any = [];
  yoyakuDivisionList: any = [];
  yoyakuData: any = [];
  yoyakuPersonList: any = [];
  outputinfo: any = {};
  opened: boolean = false;

  selectedDivisionId: string = null;
  yoyakuDataAll: any = [];

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(
    private commonService: CommonService,
    public usersService: UsersService,
    private yoyakuService: YoyakuService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}
  ngOnInit(): void {
    this.selected_yoyaku_hyo_id = +this.route.snapshot.paramMap.get("yhid");
    this.getList();
    window.scrollTo(0, 0); //画面上部へ移動
  }

  clearData(): void {
    this.isLoaded = false;
    this.selected = false;
    this.opened = false;
    this.datalist = [];
    this.yoyakuPersonList;
  }

  getList(): void {
    this.clearData();
    this.getYoyakuCalenderList();
  }
  // 予約表情報の取得
  getYoyakuCalenderList(): void {
    let params = {
      t_yoyakuhyo_id: this.selected_yoyaku_hyo_id,
    };
    this.yoyakuService.getYoyakuAdminCalenderList(params).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.yoyakuhyoInfo = res["fuel_results"]["yoyakuhyo_info"];
          this.divisionList = res["fuel_results"]["division_list"];
          this.divisionList = this.divisionList.filter(
            (v: { disabled: number }) => v.disabled === 0
          );
          this.yoyakuDivisionList = res["fuel_results"]["yoyaku_division_list"];
          this.yoyakuDataAll = res["fuel_results"]["yoyaku_data"];
          this.all_count = res["fuel_results"]["yoyaku_count"];
          this.conditionsList = res["fuel_results"]["condition_list"];
          this.title = this.yoyakuhyoInfo[0].m_yoyakuhyo_content_nm;
          //一覧の区分選択状態
          if(this.selectedDivisionId==null　&& this.yoyakuDivisionList.length>0){
            this.selectedDivisionId = this.yoyakuDivisionList[0]['division_id'];
          }
          this.selectYoyakuData();
          this.isLoaded = true;
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }
  // goYoyakuView(row: any):void{
  //   this.yoyakuViewOpen(row);
  // }
  goYoyakuView(data: any): void {
    const modalRef = this.modalService.open(
      YoyakuListViewComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" } //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    // modalRef.componentInstance.personData = this.yoyakuPersonList;
    modalRef.componentInstance.yoyakuData = data;
    modalRef.result.then(
      (result) => {
        if (result.status == "OK") {
          //
        } else {
          //
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      }
    );
  }

  cancel(): void {
    this.opened = false;
  }
  setOutputInfo(): void {
    this.opened = true;
    this.outputinfo = {
      m_yoyakuhyo_id: this.selected_yoyaku_hyo_id,
      m_yoyaku_id: null,
      start_date: null,
      end_date: null,
      selected_division_id: null,
      m_division_1_id: null,
      m_division_2_id: null,
      t_flg: false,
    };
  }
  setOutputOne(ydata,date): void {
    this.outputinfo = {
      m_yoyakuhyo_id: this.selected_yoyaku_hyo_id,
      m_yoyaku_id: ydata.m_yoyaku_id,
      start_date: date,
      end_date: date,
      selected_division_id: ydata.division_id,
      m_division_1_id: ydata.m_division_1_id,
      m_division_2_id: ydata.m_division_2_id,
      t_flg: false,
    };
    this.outputExcel();
  }
  checkDate(mode: number): boolean {
    switch (mode) {
      case 1:
        if (
          this.outputinfo.start_date == null &&
          this.outputinfo.end_date == null
        ) {
          return true;
        } else {
          return false;
        }
      //大小
      case 2:
        if (
          this.outputinfo.start_date == null ||
          this.outputinfo.end_date == null
        ) {
          return false;
        } else {
          if (
            this.commonService.exchangeDateFormat2(this.outputinfo.start_date) >
            this.commonService.exchangeDateFormat2(this.outputinfo.end_date)
          ) {
            return true;
          } else {
            return false;
          }
        }
      //データの有無
      case 3:
        var tmp = [];
        var tmp_data = [];
        var data = [];
        tmp = this.yoyakuDataAll;
        if (
          this.outputinfo.selected_division_id == null ||
          this.outputinfo.selected_division_id == "null"
        ) {
          // 処理なし
        } else {
          tmp = tmp.filter(
            (item) => item.division_id == this.outputinfo.selected_division_id && item.date_list.length > 0
          );
        }
        if (tmp.length > 0) {
          if (
            this.outputinfo.start_date != null &&
            this.outputinfo.end_date != null
          ) {
            var start = this.commonService.formatYYYYMMDD2(
              this.outputinfo.start_date
            );
            var end = this.commonService.formatYYYYMMDD2(
              this.outputinfo.end_date
            );
            for(let i = 0; tmp.length > i; i++){
              tmp_data = tmp[i].date_list.filter(
                (item) => item.yoyaku_date >= start && item.yoyaku_date <= end
              );
              if(tmp_data.length > 0){
                data.push(tmp_data);
              }
            }
          } else if (
            this.outputinfo.start_date != null &&
            this.outputinfo.end_date == null
          ) {
            var start = this.commonService.formatYYYYMMDD2(
              this.outputinfo.start_date
            );
            for(let i = 0; tmp.length > i; i++){
              tmp_data = tmp[i].date_list.filter((item) => item.yoyaku_date == start);
              if(tmp_data.length > 0){
                data.push(tmp_data);
              }
            }
          } else if (
            this.outputinfo.start_date == null &&
            this.outputinfo.end_date != null
          ) {
            var end = this.commonService.formatYYYYMMDD2(
              this.outputinfo.end_date
            );
            for(let i = 0; tmp.length > i; i++){
              tmp_data = tmp[i].date_list.filter((item) => item.yoyaku_date == end);
              if(tmp_data.length > 0){
                data.push(tmp_data);
              }
            }
          } else {
            //
          }
          if(data.length > 0){
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
    }
  }

  /**
   * 切り替えるDatePicker以外を閉じながら、
   * toggleで表示非表示を切り替える
   *
   * @param selectDp 切り替えるDatePicker
   * @param subDp 閉じるDatePicker
   */
  toggleDate(selectDp: NgbInputDatepicker, subDp: NgbInputDatepicker): void {
    selectDp.toggle();
    subDp.close();
  }
  checkList(): boolean {
    if (this.checkDate(1) || this.checkDate(2)) {
      return true;
    } else {
      return false;
    }
  }
  outputExcel(): void {
    this.commonService.modalOpens(
      53001,
      //ファイルを出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          if (typeof this.outputinfo.start_date === "string") {
          } else {
            this.outputinfo.start_date = this.commonService.formatYYYYMMDD2(
              this.outputinfo.start_date
            );
          }
          if (typeof this.outputinfo.end_date === "string") {
          } else {
            this.outputinfo.end_date = this.commonService.formatYYYYMMDD2(
              this.outputinfo.end_date
            );
          }

          if (
            this.outputinfo.selected_division_id == null ||
            this.outputinfo.selected_division_id == "null"
          ) {
            this.outputinfo.m_division_1_id = null;
            this.outputinfo.m_division_2_id = null;
          } else {
            var tempdiv = [];
            //～でsplit
            tempdiv = this.outputinfo.selected_division_id.split("_");
            this.outputinfo.m_division_1_id = tempdiv[0];
            this.outputinfo.m_division_2_id = tempdiv[1] = 0
              ? null
              : tempdiv[1];
          }
          this.yoyakuService.outputYoyakulistExcel(this.outputinfo);
          this.outputinfo.selected_division_id = null;
          this.outputinfo.start_date = null;
          this.outputinfo.end_date = null;
        } else {
          //
        }
      }
    );
  }
  selectYoyakuData(): void{
    this.yoyakuData = this.yoyakuDataAll.filter(
      (v: { division_id: string }) => v.division_id === this.selectedDivisionId
    );
  }
  goManintenance(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.router.navigate(["/yoyaku-maintenance"]);
          }
        }
      );
    } else {
      this.router.navigate(["/yoyaku-maintenance"]);
    }
  }
  goBack(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.location.back();
          }
        }
      );
    } else {
      this.location.back();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/a2104-yoyaku-list/yoyaku-list.component.ts